import { render } from "./Nominee.vue?vue&type=template&id=6686cb3e"
import script from "./Nominee.vue?vue&type=script&lang=js"
export * from "./Nominee.vue?vue&type=script&lang=js"

import "./Nominee.vue?vue&type=style&index=0&id=6686cb3e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__